// import { store } from "../../store/store"; // Pfad zu deinem Store-File
// import { setStations } from "../../store/app/stations";

interface Coordinates {
  lat: number;
  lng: number;
}

class ORMStations {
  deg2rad = (deg: number) => {
    return deg * (Math.PI / 180);
  };

  calculateDistance = (station: Coordinates, user: Coordinates) => {
    // console.log(posUser);
    const lat1 = user.lat;
    const lng1 = user.lng;
    const lat2 = station.lat;
    const lng2 = station.lng;

    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(lat2 - lat1); // deg2rad below
    const dLng = this.deg2rad(lng2 - lng1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return parseInt(d.toString());
    // return Math.round((d + Number.EPSILON) * 100) / 100;
  };

  compare(a: any, b: any) {
    if (a.distance < b.distance) return -1;
    if (a.distance > b.distance) return 1;
    return 0;
  }

  stationDistance = async (station: any, user: Coordinates) => {
    const ResFor = JSON.parse(JSON.stringify(station));

    // for (const element of ResFor) {
    if (ResFor.latitude) {
      const distance = this.calculateDistance(
        { lat: ResFor.latitude, lng: ResFor.longitude },
        user,
      );
      ResFor.distance = distance;
    }
    return ResFor;
  };
}

const ormStations = new ORMStations();
export default ormStations;
